<template>
<!-- <v-container> -->
<v-stepper v-model="el">
    <v-stepper-header>
        <v-stepper-step :complete="el > 1" step="1"> Event </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2"> Invitations </v-stepper-step>
    </v-stepper-header>
    <notifications position="bottom right" group="event" />

    <v-stepper-items>
        <v-stepper-content step="1" classs="glass-element">
            <v-card>
                <v-card-text>
                    <v-form v-model="valid" v-if="el == 1">
                        <h2>
                            {{ event ? `Edit ${event.event_title}` : "Add new event" }}
                        </h2>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="formData.event_title" id="title" label="Event title" :rules="validateTitle">
                                </v-text-field>
                            </v-col>
                            <v-col v-if="eventTypes">
                                <v-select :items="eventTypes" item-text="event_type_name" item-value="id" v-model="formData.event_type_event" label="Event type"></v-select>
                            </v-col>
                            <v-col>
                                <v-checkbox id="event_private" v-model="formData.event_private" name="event_private" label="Private event">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :rules="minParticipantsRules" hide-details="auto" type="number" v-model="formData.event_min_participants" label="Min participants"></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field :rules="minParticipantsRules" hide-details="auto" type="number" v-model="formData.event_max_participants" label="Max participants"></v-text-field>
                            </v-col>

                            <v-col>
                                <v-textarea id="event-description" label="Description" v-model="formData.event_description">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-datetime-picker label="From" v-model="formData.event_datetime_start">
                                </v-datetime-picker>
                                <v-datetime-picker label="To" v-model="formData.event_datetime_end">
                                </v-datetime-picker>
                            </v-col>

                            <v-col>
                                <v-text-field v-model="formData.event_address" id="address" label="Address" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-alert dismissible v-if="error != null">
                            {{ error }}
                        </v-alert>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="!loading" :disabled="!valid" @click="save">Save</v-btn>
                    <SmallLoaderLight v-if="loading" />
                    <v-btn color="primary" v-if="!loading" @click="saveContinue">
                        Save and Continue
                    </v-btn>

                    <v-btn @click="cancel"> Cancel </v-btn>
                </v-card-actions>
            </v-card>

        </v-stepper-content>

        <v-stepper-content step="2" classs="glass-element">
            <v-card>
                <v-card-text>

                    <h2>{{ formData.event_title }}</h2>
                    <p>select people to invite</p>
                    <InviteForm :event_slug="formData.event_slug" :event_id="formData.event_id" />
                </v-card-text>
            </v-card>

            <v-btn v-if="!loading" @click="save"> Done </v-btn>
            <SmallLoaderLight v-if="loading" />
        </v-stepper-content>
    </v-stepper-items>
</v-stepper>
</template>

<script>
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import {
    mapState
} from "vuex";
import InviteForm from "@/components/molecules/InviteForm";

export default {
    components: {
        SmallLoaderLight,
        InviteForm
    },
    props: ["event"],
    data() {
        return {
            mapLoading: false,
            picker: new Date().toISOString().substr(0, 10),
            date: null,
            loading: false,
            error: null,
            valid: null,
            el: 1,
            setStartTime: true,
            formData: {
                event_title: "",
                event_datetime_start: "",
                event_datetime_end: "",
                event_description: null,
                event_min_participants: 1,
                event_max_participants: 12,
                event_private: false,
                event_address: null,
                event_host: null,
                event_type_event: 1,
                event_lat: 0,
                event_lon: 0,
            },
        };
    },
    computed: mapState({
        error: (state) => state.errors.createEvent,
        ownProfile: (state) => state.profiles.ownProfile,
        eventTypes: (state) => state.events.types.filter((e) => e.event_type_name == "game"),
        validateTitle() {
            return this.formData.event_title.length > 0;
        },
    }),
    watch: {
        formData: {
            handler: function (newValue, oldValue) {
                if (newValue.event_datetime_start && !oldValue.event_datetime_end) {
                    newValue.event_datetime_end = newValue.event_datetime_start;
                }
            },
            deep: true,
        },
    },
    methods: {
        formatDate(date) {
            if (!date) {
                return;
            }
            let dt = new Date(date);
            return dt.toISOString();
        },
        setTime(e) {
            this.formData[
                this.setStartTime ? "event_datetime_start" : "event_datetime_end"
            ] = e;
        },
        async save() {
            if (
                !this.formData.event_title ||
                !this.formData.event_datetime_start ||
                !this.formData.event_type_event ||
                !this.formData.event_min_participants
            ) {
                this.error =
                    "Fill in all compulsory fields (title, starting datetime, event type, min number of participants).";
                return;
            }
            this.error = null;
            this.loading = true;
            this.$store.commit("RESET_CREATE_EVENT_ERROR");
            this.formData.event_datetime_start = this.formatDate(
                this.formData.event_datetime_start
            );
            this.formData.event_datetime_end = this.formatDate(
                this.formData.event_datetime_end
            );
            this.formData.event_host =
                this.formData && this.formData.event_host && this.formData.event_host.id ?
                this.formData.event_host.id :
                this.ownProfile.id;
            this.formData.event_status = "PU";
            if (this.event) {
                if (this.event.invitations) {
                    delete this.event.invitations;
                }
                await this.$store
                    .dispatch("editEvent", {
                        ...this.formData,
                        event_slug: this.event.event_slug,
                    })
                    .then((data) => {
                        this.loading = false;
                        if (data.success) {
                            this.$store.dispatch("getMyEvents");
                            this.$store.dispatch("getEvents");
                            this.$router.push("/my_events").catch(() => {});
                            this.$notify({
                                group: 'event',
                                title: "event modified",
                                type: 'success',
                                text: 'event updated.',
                            })
                        } else {
                            this.$notify({
                                group: 'event',
                                title: "error",
                                type: 'error',
                                text: data?.data?.non_field_errors[0],
                            })
                        }

                    });
            } else {
                await this.$store
                    .dispatch("createEvent", this.formData)
                    .then((data) => {
                        this.loading = false;
                        if (data.success) {
                            this.$router.push("/event/details/" + data.data.event_slug);
                        }
                    });
            }
        },
        async saveContinue() {
            if (
                !this.formData.event_title ||
                !this.formData.event_datetime_start ||
                !this.formData.event_type_event ||
                !this.formData.event_min_participants
            ) {
                this.error =
                    "Fill in all compulsory fields (title, starting datetime, event type, min number of participants.";
                return;
            }
            this.error = null;
            this.loading = true;
            this.$store.commit("RESET_CREATE_EVENT_ERROR");
            this.formData.event_datetime_start = this.formatDate(
                this.formData.event_datetime_start
            );
            this.formData.event_datetime_end = this.formatDate(
                this.formData.event_datetime_end
            );
            this.formData.event_host = this.formData?.event_host?.id ?
                this.formData.event_host.id :
                this.ownProfile.id;
            if (this.event) {
                if (this.event.invitations) {
                    delete this.event.invitations;
                }
                await this.$store
                    .dispatch("editEvent", {
                        ...this.formData,
                        event_slug: this.event.event_slug,
                    })
                    .then((data) => {
                        if (data.success) {
                        this.el = 2;
                            this.$notify({
                                group: 'event',
                                title: "event modified",
                                type: 'success',
                                text: 'Event updated!',
                            })
                        } else {
                            this.$notify({
                                group: 'event',
                                title: "error",
                                type: 'error',
                                text: data?.data?.non_field_errors[0],
                            })
                        }
                        this.loading = false;

                    });
            } else {
                await this.$store.dispatch("createEvent", this.formData).then((data) => {
                    if (data.success) {
                        if (data.data.event_datetime_start) {
                            let date = data.data.event_datetime_start.split("GMT")[0];
                            let dateParse = Date.parse(date);
                            this.formData.event_datetime_start = new Date(dateParse);
                        }
                        if (data.data.event_datetime_end) {
                            let date = data.data.event_datetime_end.split("GMT")[0];
                            let dateParse = Date.parse(date);
                            this.formData.event_datetime_end = new Date(dateParse);
                        }
                        this.formData.event_slug = data.data.event_slug;
                        this.formData.event_id = data.data.event_id;
                        this.formData.event_status = data.data.event_status;
                        this.event = {
                            ...this.formData
                        };
                        this.el = 2;
                    }
                    this.loading = false;
                });
            }

        },
        cancel() {
            this.$router.push("/");
        },
    },
    mounted() {
        this.$store.dispatch("getTypes");
        if (this.event) {
            this.formData = {
                ...this.event
            };
            if (this.formData.event_datetime_start) {
                this.formData.event_datetime_start = new Date(
                    this.formData.event_datetime_start
                );
            }
            if (this.formData.event_datetime_end) {
                this.formData.event_datetime_end = new Date(
                    this.formData.event_datetime_end
                );
            }
        }
    },
};
</script>
